import React, {useCallback} from 'react';
import cx from './index.module.scss';
import CopyButton from '../CopyButton';
import About from '../About';
import { ReactComponent as IconInfo } from '../../assets/images/icon_info.svg';
import SearchButton from '../SearchButton';

const Intro = ({onSearch, company, setModal}) => {
  const handleOpenModal = useCallback(() => {
    setModal(<About />);
  }, [setModal]);

  return (
    <div className={cx.wrap}>
      <div className={cx.container}>
        <div className={cx.title}>
          <img className={cx.titleImage} src={`${process.env.PUBLIC_URL}/images/title_start.png`} alt="우리 회사는 1960년대?"/>
        </div>
        <div className={cx.searchButtonWrap}>
          <SearchButton onSearch={onSearch} />
        </div>
        <div className={cx.description}>
          재직자가 평가한 우리 회사의{' '}
          <button className={cx.tooltipButton} onClick={handleOpenModal} type="button">
            블라인드 지수<IconInfo className={cx.iconInfo} />
          </button>
          를 연도로 계산해 보여줍니다.
        </div>
        <div className={cx.copyButtonWrap}>
          <CopyButton company={company} />
        </div>
      </div>
      <div className={cx.imageWrap}>
        <img className={cx.image} src={`${process.env.PUBLIC_URL}/images/ill_start.png`} alt=""/>
      </div>
    </div>
  )
};

export default Intro;
